import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { DialogService, DspxCardSetBaseFormComponent, SpinnerService } from 'dspx-core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseParserService } from '../../services/response-parser.service';
import { AppDataService } from '../../services/app-data.service';
import { ExcelImportService } from '../../services/excel-import.service';
import { TEMPLATES } from '../../constants/templates.constants';
import { API_ENDPOINTS } from '../../constants/api-endpoints.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';

@Component({
  selector: 'app-gl-string-lookup-mapping-set-list',
  templateUrl: './gl-string-lookup-mapping-set-list.component.html',
  styleUrl: './gl-string-lookup-mapping-set-list.component.scss'
})
export class GLStringLookupMappingSetListComponent extends BaseCardSetListComponent implements OnInit, OnDestroy {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  activeDialog: string = '';

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    protected excelImportService: ExcelImportService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.glStringLookupMappingSetList,
      () => API_ENDPOINTS.dashboard.getGlStringLookupMappingSets,
      false
    );
  }

  ngOnInit(): void {
    this.route.url.subscribe((url) => {
      if (url.length === 0) {
        // In the case where this component is being loaded as part of the default (empty) route, we want to force it
        // to the Reference Data List route so that the menu will highlight the selected option.
        this.router.navigate(['/', ROUTE_CONSTANTS.glStringLookupMappingSet.list]);
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
  }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
    // No filters are implemented in this dashboard
  }

  actionButton_mappingsGrid_datagrid_new_Clicked(event: any) {
    this.router.navigate(['/', ROUTE_CONSTANTS.glStringLookupMappingSet.prefix]);
  }

  actionButton_mappingsGrid_datagrid_edit_Clicked(event: any) {
    this.router.navigate(['/', ROUTE_CONSTANTS.glStringLookupMappingSet.prefix, event.event.data.id]);
  }
}
